import { useMutation } from '@apollo/client'
import { ModalConfirm, useMessage } from '@faceup/ui-base'
import { type FragmentType, getFragmentData, graphql } from '../__generated__'

const fragments = {
  TransferOwnershipModal_member: graphql(`
    fragment TransferOwnershipModal_member on Member {
      id
      name
    }
  `),
  TransferOwnershipModal_institution: graphql(`
    fragment TransferOwnershipModal_institution on Company {
      id
    }
  `),
}

const mutations = {
  TransferOwnership: graphql(`
    mutation TransferOwnershipMutation($memberId: UUID!, $motherId: UUID!) {
      transferOwnership(input: { memberId: $memberId, motherId: $motherId }) {
        oldOwner {
          id
          accountType(motherId: $motherId)
        }

        newOwner {
          id
          accountType(motherId: $motherId)
        }
      }
    }
  `),
}

type TransferOwnershipModalProps = {
  member: FragmentType<typeof fragments.TransferOwnershipModal_member> | null
  institution: FragmentType<typeof fragments.TransferOwnershipModal_institution>
  onClose: () => void
}

export const TransferOwnershipModal = ({
  member: _member,
  institution: _institution,
  onClose,
}: TransferOwnershipModalProps) => {
  const member = getFragmentData(fragments.TransferOwnershipModal_member, _member)
  const institution = getFragmentData(fragments.TransferOwnershipModal_institution, _institution)
  const message = useMessage()
  const [transfer, { loading }] = useMutation(mutations.TransferOwnership, {
    onCompleted: () => {
      message.success('Ownership transferred successfully')
      onClose()
    },
  })

  if (!member) {
    return null
  }

  return (
    <ModalConfirm
      title='Transfer ownership'
      open
      onCancel={onClose}
      onConfirm={async () => {
        transfer({
          variables: {
            memberId: member.id,
            motherId: institution.id,
          },
        })
      }}
      confirmState={{ loading }}
    >
      Are you sure you want to transfer ownership to <strong>{member.name}</strong>?
    </ModalConfirm>
  )
}
